/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {
    FC,
    getProp,
    PointLike,
    copyPointData,
    $Container, ContainerProps, CanBeSignal, splitProps
} from '@gongxigames/framework/core/fragments/BuilderY';
import {Store} from '@gongxigames/framework/core/fragments/store';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {Point} from 'pixi.js';

type GameAlignContainerProps = Omit<ContainerProps, 'position' | 'scale'> & {
    align?: CanBeSignal<PointLike>;
    offset?: CanBeSignal<PointLike>;
    scale?: CanBeSignal<PointLike>;
};

export const $GameAlignContainer: FC<GameAlignContainerProps> = (props) => {
    const tmpAlign = new Point();
    const tmpOffset = new Point();
    const tmpScale = new Point();

    const scale = Store.computed(() => {
        copyPointData(getProp(props.scale) ?? 1, tmpScale);

        return new Point(tmpScale.x, tmpScale.y);
    });

    const position = Store.computed(() => {
        // the value of stage_safeZoneState_game updates on resize event
        const safeZone = slotStore.stage_safeZoneState_game.value!;
        const {width, height} = safeZone.options.contentSize;

        copyPointData(getProp(props.align) ?? 0, tmpAlign);

        const x = width * tmpAlign.x;
        const y = height * tmpAlign.y;

        return new Point(x, y);
    });

    const offset = Store.computed(() => {
        copyPointData(getProp(props.offset) ?? 0, tmpOffset);

        return new Point(tmpOffset.x, tmpOffset.y);
    });

    const excludeScaleProps = splitProps(props, ['scale'])[1];

    return <$Container name='GameAlignContainer' position={position} scale={scale}>
        <$Container {...excludeScaleProps} position={offset}/>
    </$Container>;
};